import { Alert, AlertTypography, Link } from '@ace-clublabs/shared-component-library';

export interface IActiveMemberAlertProps {
  visible: boolean;
  variant: 'active' | 'error' | undefined;
}

export const ActiveMemberAlert = ({ visible, variant }: IActiveMemberAlertProps) => {
  const phoneLink = (
    <Link variant="b2Regular" href="tel:1-844-786-1615" target="_blank">
      1-844-786-1615
    </Link>
  );

  const message =
    variant === 'active' ? (
      <AlertTypography>
        We cannot add this person as an associate because they’re already a member. Please call {phoneLink} for
        assistance.
      </AlertTypography>
    ) : (
      <AlertTypography>
        Sorry we couldn’t update your information. Please give us a call at {phoneLink}.
      </AlertTypography>
    );

  if (!visible) {
    return <></>;
  }

  return (
    <Alert severity="error" displayCloseButton={false} sx={{ marginBottom: '1rem' }}>
      {message}
    </Alert>
  );
};
